import type { IcIcon } from "./types";

export const IcChevronLeft: IcIcon = (properties) => (
  <svg
    display="block"
    height="1.5em"
    viewBox="0 0 13 22"
    width="1.5em"
    xmlns="http://www.w3.org/2000/svg"
    {...properties}
  >
    <path
      d="M13 19.05 4.919 11 13 2.95 10.54.5 0 11l10.54 10.5z"
      fill="currentColor"
    />
  </svg>
);
